

























import Vue from "vue";
// View
import DashboardContent from "@/views/Dashboard/DashboardContent.vue";
// Components
import Leftbar from "@/components/Bar/Leftbar/Leftbar.vue";
import TopBar from "@/components/Bar/TopBar/TopBar.vue";
import Spinner from "@/components/Spinner/Spinner.vue";
// Store
import { store } from "@/store/store";
import { StateActionsTypes } from "@/store/modules/State/types";
import { DeviceActionsTypes } from "@/store/modules/Device/types";
import { CategoryActionsTypes } from "@/store/modules/Category/types";
import { SurveyActionsTypes } from "@/store/modules/Survey/types";
import { LogActionsTypes } from "@/store/modules/Log/types";
import { ActionTypes } from "@/store/modules/Auth/actions-types";
import { CameraResolutionActionsTypes } from "@/store/modules/CameraResolution/types";
import { User } from "@/store/modules/User/interface";
import { MainStateActionsTypes } from "../../store/modules/MainState/types";
import { CameraImageActionsTypes } from "@/store/modules/CameraImage/types";
import { PosteActionsTypes } from "@/store/modules/Poste/types";
import { UserActionsTypes } from "@/store/modules/User/types";
import { RoleActionsTypes } from "@/store/modules/Role/types";
import { AgenceActionsTypes } from "@/store/modules/Agence/types";

interface DashboardData {
  /**
   * @type {string}
   * @description url where user is actually
   */
  routeName: string;
  /**
   * @type {boolean}
   * @description check if the component is mounted or not
   */
  isMounted: boolean;
}

/**
 * @description Dashboard is the first component of the application, he is here to fetch
 * all the data needed to display and also re-render component when route is updated
 * @export
 * @class Dashboard
 * @extends {Vue}
 */
export default Vue.extend({
  name: "Dashboard",
  async created(): Promise<void> {
    sessionStorage.setItem("last_update", "");
    await this.fetchData();
    this.isMounted = true;
  },
  components: { Leftbar, TopBar, Spinner, DashboardContent },
  data(): DashboardData {
    return {
      routeName: this.$route.name as string,
      isMounted: false
    };
  },
  mounted(): void {
    this.recurrentUpdate();
  },
  methods: {
    /**
     *  @description Recurrently refresh the data of the store and the user token to keep user connected and updated
     *  @param  {string} refresh
     *  @return {void}
     */
    recurrentUpdate() {
      setInterval(async () => this.fetchData(true), 1000 * 60 * 10);
    },
    /**
     *  @description Fetch all the necessary data from the api
     *
     *  if refresh is true, the token is gonna be refreshed
     *  if refresh is false, the View will be set
     *
     *  @param  {string} refresh
     *  @return {void}
     */
    async fetchData(refresh = false): Promise<void> {
      await store.dispatch(UserActionsTypes.GET_LOGGED_USER);
      await store.dispatch(UserActionsTypes.LIST_USER);
      await store.dispatch(RoleActionsTypes.LIST_ROLE);
      await store.dispatch(AgenceActionsTypes.LIST_AGENCE);
      await store.dispatch(StateActionsTypes.LIST_STATE);
      await store.dispatch(DeviceActionsTypes.LIST_DEVICE);
      await store.dispatch(DeviceActionsTypes.LIST_DEVICE_BY_DAY);
      await store.dispatch(CategoryActionsTypes.LIST_CATEGORY);
      await store.dispatch(SurveyActionsTypes.LIST_SURVEY);
      await store.dispatch(LogActionsTypes.LIST_LOG);
      await store.dispatch(MainStateActionsTypes.LIST_MAIN_STATE);
      await store.dispatch(CameraResolutionActionsTypes.LIST_CAMERA_RESOLUTION);
      await store.dispatch(CameraImageActionsTypes.LIST_CAMERA_IMAGE);
      await store.dispatch(PosteActionsTypes.LIST_POSTE);
      if (refresh) await store.dispatch(ActionTypes.REFRESH_AUTH);
      else this.defineView();

      sessionStorage.setItem("last_update", new Date().getTime().toString());
    },
    /**
     * @description Define the view to display
     *
     *  @return {void}
     */
    defineView() {
      const user = store.getters.LOGGED_USER as User;
      const role = store.getters.ROLE_BY_ID[user.role].name.toUpperCase();
      if (role === "ADMIN") store.dispatch(ActionTypes.SET_VIEW, role);
      else store.dispatch(ActionTypes.SET_VIEW, store.getters.AGENCE_BY_ID[user.agence]._id);
    }
  },
  watch: {
    /*
     * the route watcher is here to re-render the dashboard content component if the route has changed.
     */
    $route: {
      handler(route): void {
        this.routeName = route.name;
      },
      immediate: true
    }
  }
});
